<template>
    <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="TIEMPO EXTRA" key="1">
            <a-card hoverable>
                <a-card-meta :title="$store.state.userInfo.employee.nombre"
                             :description="$store.state.userInfo.employee.cargo">
                    <a-avatar
                            slot="avatar"
                            :src="profileSrc"
                    />
                </a-card-meta>
            </a-card>
            <br>
            <g-master name="wfrequestmaster"
                      :endpoint="extraWorkMaster.endpoint"
                      :tableSetup="extraWorkMaster.tableSetup"
                      :modalFieldsSetup="extraWorkMaster.modalFieldsSetup"
                      @action="extraWorkMasterAction"
                      @fieldsChange="fieldsChange"
                      ref="extaWorkMaster">
            <span slot="estadoRenderer" slot-scope="{text}">
                    <a-tag :color="text===estados.ESTADO_RECHAZADO ? 'red' : (text === estados.ESTADO_LIQUIDACION ? 'green' : 'blue')">{{text}}</a-tag>
                </span>

                <template slot="masterModal" slot-scope="{registro}">
                    <a-form-item label="Fecha Inicio" v-bind="extraWorkMaster.fiOptions">
                        <a-date-picker style="width: 100%"
                                       v-decorator="['start_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                    </a-form-item>

                    <a-form-item label="Programación" v-bind="extraWorkMaster.fiOptions">
                        <a-textarea v-model="extraWorkMaster.user_review.value"
                                    disabled>
                            <a-tooltip slot="suffix" title="Programación">
                                <a-icon v-if="extraWorkMaster.user_review.loading" type="loading"/>
                                <a-icon v-else type="info-circle" style="color: rgba(0,0,0,.45)"/>
                            </a-tooltip>
                        </a-textarea>
                    </a-form-item>

                    <a-form-item label="Hora Inicio" v-bind="extraWorkMaster.fiOptions">
                        <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                                       v-decorator="['start_time', {type:'object', rules: [{ required: true, message: 'Valor requerido' }] }]"
                                       placeholder="H. Inicio"
                                       style="width: 100%"
                        ></a-time-picker>
                    </a-form-item>

                    <a-form-item label="Fecha Fin" v-bind="extraWorkMaster.fiOptions">
                        <a-date-picker style="width: 100%"
                                       v-decorator="['end_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
                    </a-form-item>

                    <a-form-item label="Hora Finl" v-bind="extraWorkMaster.fiOptions">
                        <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                                       v-decorator="['end_time', {type:'object', rules: [{ required: true, message: 'Valor requerido' }] }]"
                                       placeholder="H. Fin"
                                       style="width: 100%"></a-time-picker>
                    </a-form-item>

                    <a-form-item label="Actividad" v-bind="extraWorkMaster.fiOptions" v-if="true">
                        <a-input placeholder="Actividad"
                                 v-decorator="['work', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                        </a-input>
                    </a-form-item>
                </template>
            </g-master>

            <a-modal title="Confirmación"
                     :visible="aprobarRechazar.visible"
                     @ok="confirmarConfirmacionAprobar"
                     :confirmLoading="aprobarRechazar.loading"
                     @cancel="cancelarConfirmacionAprobar">
                <p>¿Está seguro de {{aprobarRechazar.aprobar ? 'aprobar' : 'rechazar'}} la solicitud?</p>
                <a-alert type="error" :message="aprobarRechazar.mensaje" v-if="aprobarRechazar.mensaje != ''"/>
            </a-modal>
        </a-tab-pane>
    </a-tabs>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import JsUtils from '@/util/JsUtils'
  import DateUtils from '@/util/DateUtils'
  import ATextarea from 'ant-design-vue/es/input/TextArea'

  const ESTADO_ACTIVO = 'ACTIVO'
  const ESTADO_CERRADO = 'CERRADO'
  const ESTADO_RECHAZADO = 'RECHAZADO'
  const ESTADO_LIQUIDACION = 'LIQUIDACION'
  export default {
    components: {ATextarea},
    data () {
      return {
        profileSrc: require('./../../../assets/anon_profile.png'),
        defaultPicture: require('./../../../assets/anon_profile.png'),
        estados: {
          ESTADO_ACTIVO,
          ESTADO_CERRADO,
          ESTADO_RECHAZADO,
          ESTADO_LIQUIDACION
        },
        extraWorkMaster: {
          endpoint: 'extra_work',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Cod. Empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Empleado', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'Fecha Inicio', dataIndex: 'start_date_desc', sorter: true},
              {title: 'H. Inicio', dataIndex: 'start_time', sorter: true},
              {title: 'Fecha Fin', dataIndex: 'end_date_desc', sorter: true},
              {title: 'H. Fin', dataIndex: 'end_time', sorter: true},
              {title: 'Actividad', dataIndex: 'work', sorter: true},
              {title: 'Cod. Emp. Reemplazo', dataIndex: 'id_emp_replace', sorter: true},
              {title: 'Emp. Reemplazo', dataIndex: 'nombre_empleado_reemplazo', sorter: true},
              {title: 'Programación', dataIndex: 'programacion', sorter: true},
              {title: 'Creado Por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado En', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado Por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado En', dataIndex: 'modified_on', sorter: true}
            ],
            actions: {
              title: 'Acciones',
              scopedSlots: {customRender: 'hooverableAction'},
              width: 90,
              fixed: 'right',
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return record.id_emp === this.$store.state.userInfo.id_emp
                      && (record.estado === ESTADO_ACTIVO || record.estado === ESTADO_RECHAZADO)
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'delete'},
                  fnVisible: (record) => {
                    return record.id_emp === this.$store.state.userInfo.id_emp
                      && record.estado === ESTADO_ACTIVO
                  }
                },
                {
                  name: 'aprobar',
                  text: 'Aprobar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color: green'},
                  fnVisible: (record) => {
                    return record.id_emp_jefe === this.$store.state.userInfo.id_emp
                      && record.estado === ESTADO_ACTIVO
                  }
                },
                {
                  name: 'rechazar',
                  text: 'Rechazar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'close', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.id_emp_jefe === this.$store.state.userInfo.id_emp
                      && record.estado === ESTADO_ACTIVO
                  }
                },
              ]
            },
            customSlots: ['estadoRenderer']
          },
          modalFieldsSetup: [
            {name: 'start_date', type: 'date'},
            {name: 'start_time', type: 'time'},
            {name: 'end_date', type: 'date'},
            {name: 'end_time', type: 'time'},
            {name: 'work'}
          ],
          fiOptions: {
            'label-col': {span: 6},
            'wrapper-col': {span: 18},
            'has-feedback': true
          },
          period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
          user_review: {
            loading: false,
            value: ''
          }
        },
        aprobarRechazar: {
          visible: false,
          loading: false
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.loadEmployPicture()
    },
    methods: {
      extraWorkMasterAction (action) {
        switch (action.action) {
          case 'aprobar':
            this.aprobarRechazar.aprobar = true
            this.aprobarRechazar.id = action.record.id
            this.aprobarRechazar.visible = true
            this.aprobarRechazar.mensaje = ''
            this.aprobarRechazar.loading = false
            break
          case 'rechazar':
            this.aprobarRechazar.aprobar = false
            this.aprobarRechazar.id = action.record.id
            this.aprobarRechazar.visible = true
            this.aprobarRechazar.mensaje = ''
            this.aprobarRechazar.loading = false
            break
        }
      },
      confirmarConfirmacionAprobar () {
        this.aprobarRechazar.loading = true
        this.httpClient.getInstance().post('extra_work/aprobar_rechazar', {
          id: this.aprobarRechazar.id,
          aprobar: this.aprobarRechazar.aprobar
        })
          .then(response => {
            if (response.data.resultado !== '2') {
              this.aprobarRechazar.mensaje = response.data.mensaje
            } else {
              Mensajes.success('Correcto', response.data.mensaje)
              this.refreshMasterTable()
              this.cancelarConfirmacionAprobar()
            }
          })
          .catch(error => {
            this.aprobarRechazar.mensaje = error && error.response && error.response.data && error.response.data.mensaje
          })
          .then(() => {
            this.aprobarRechazar.loading = false
          })
      },
      cancelarConfirmacionAprobar () {
        this.aprobarRechazar.aprobar = null
        this.aprobarRechazar.visible = false
        this.aprobarRechazar.mensaje = ''
        this.aprobarRechazar.loading = false
      },
      refreshMasterTable () {
        this.$refs.extaWorkMaster.$refs.datatable.loadData()
      },
      loadEmployPicture (idPerson) {
        this.profileSrc = this.defaultPicture
        this.httpClient.getInstance().get('picture_service/render/profile/' + this.$store.state.userInfo.id_person, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
      },
      fieldsChange (values) {
        if (!JsUtils.isEmpty(values.start_date) && !JsUtils.isEmpty(values.start_date.value)) {
          console.log('cambiado')
          this.$nextTick(() => {
            this.extraWorkMaster.user_review.loading = true
            this.extraWorkMaster.user_review.value = ''

            this.httpClient.getInstance().get('extra_work/user_review', {
              params: {
                start_date: DateUtils.forBackEnd(values.start_date.value),
                x: Math.random()
              }
            })
              .then((response) => {
                this.extraWorkMaster.user_review.value = response.data
              })
              .catch(() => {
                this.extraWorkMaster.user_review.value = 'No fue posible consultar esta información.'
              })
              .then(() => {
                this.extraWorkMaster.user_review.loading = false
              })
          })
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/ExtraWork/ExtraWork.vue